import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import cleanedQueue from "../../../images/cleanedQueue.svg"
import { updateSellerPIPunchToHighPriority } from "../../../services/api/sellerPIPunch";

import { FixedSizeList as List } from "react-window";

import QueueRow from "./QueueRow";
import { checkPermissions } from "../../../utils";

const PIQueue = (props) => {
    const { pendingProcessLineItems, handleRefreshQueue, sellerPIProcessLine, setIsLoading } = props

    const dispatch = useDispatch()

    const usersData = useSelector(state => state.userDetails)

    const [globalElapsedTime, setGlobalElapsedTime] = useState(0)

    useEffect(() => {
        const interval = setInterval(() => {
            setGlobalElapsedTime((prevTime) => prevTime + 1000)
        }, 1000)

        return () => clearInterval(interval)
    }, [])

    const handleCopyClick = (docNo) => {
        if (docNo) {
            navigator.clipboard.writeText(docNo)
                .then(() => dispatch(raiseToast({ severity: 'success', summary: 'PIDoc No', detail: "Successfully copied" })))
                .catch(() => dispatch(raiseToast({ severity: 'error', summary: 'PIDoc No', detail: "Can't copy" })))
        }
    }

    const handleRaisePriority = async (linkDocId) => {
        let {isRaisePriorityPermitted} = checkPermissions({ ...usersData, permissions: [265] })

        if (isRaisePriorityPermitted){
            if (window.confirm('Are you sure to raise priority?')) {
                setIsLoading(true)
                const response = await updateSellerPIPunchToHighPriority({ sellerPIPunchId: linkDocId })
                setIsLoading(false)
                if (response.failure) {
                    return dispatch(raiseToast({ severity: 'error', summary: "Raise Priority", detail: response.data.error, life: 3000 }))
                }
                else {
                    handleRefreshQueue()
                    return dispatch(raiseToast({ severity: 'success', summary: "Raise Priority", detail: 'Priority raised successfully.', life: 3000 }))
                }
            }
        }else {
            return dispatch(raiseToast({ severity: 'warn', detail: 'Raise priority access has been denied.' }))
        }
    }

    return (
        <div className="pi-queue">
            {pendingProcessLineItems.length > 0 ?
                <>
                    <div className="flex flex-row items-center justify-content-end gap-4 mb-4">
                        <div className="flex flex-row items-center">
                            <div style={{ width: "40px", height: "12px", borderRadius: "50px", backgroundColor: "#E7C499" }}></div>
                            <span className="ml-1 text-sm text-gray-700" style={{ lineHeight: "12px" }}>Priority</span>
                        </div>
                        <div className="flex items-center">
                            <div style={{ width: "40px", height: "12px", borderRadius: "50px", backgroundColor: "#a3c9ea" }}></div>
                            <span className="ml-1 text-sm text-gray-700" style={{ lineHeight: "12px" }}>Skipped</span>
                        </div>
                        <div className="flex items-center">
                            <div style={{ width: "40px", height: "12px", borderRadius: "50px", backgroundColor: "lightgrey" }}></div>
                            <span className="ml-1 text-sm text-gray-700" style={{ lineHeight: "12px" }}>Low Priority</span>
                        </div>
                    </div>
                    <div className="table-container">
                        <div className="table-header bg-grey-300">
                            <div>Sr. No</div>
                            <div>PI DocNo</div>
                            <div>KAM Name</div>
                            <div>Buyer Company</div>
                            <div>Seller Company</div>
                            <div>Total PI Amount</div>
                            <div>Queued For: HH:MM:SS</div>
                        </div>
                        <List
                            height={400} 
                            itemCount={pendingProcessLineItems.length}
                            itemSize={60} 
                            width={"100%"} 
                            overscanCount={50}
                            itemData={{
                                pendingProcessLineItems,
                                usersData,
                                sellerPIProcessLine,
                                handleCopyClick,
                                handleRaisePriority,
                                globalElapsedTime,
                            }}
                        >
                            {QueueRow}
                        </List>
                    </div>
                </>
                :
                <div className="flex flex-column justify-content-between align-items-center p-6">
                    <img src={cleanedQueue} alt="Empty Queue" style={{ width: "100px", height: "100px" }} />
                    <h3 className="text-xl font-semibold text-gray-700">Queue is Empty!</h3>
                    <p className="text-gray-500 text-sm mt-1">No pending PI at the moment. You're all caught up!</p>
                </div>
            }
        </div>
    )
}

export default PIQueue